import { MoneyConnectClientAPI } from "./axios-service-creator";

export const ConsolidateAPI = {
  getAccounts: () => MoneyConnectClientAPI.get("/consolidate/customer/accounts"),
  registerPWM: (payload) => MoneyConnectClientAPI.post("/consolidate/pwm/register", payload),
  initialRequestStatementForm: (signal) =>
    MoneyConnectClientAPI.get("/consolidate/portfolio/defaultDataGenPortfolioReport", { signal }),
  sendRequestStatement: (payload, signal) =>
    MoneyConnectClientAPI.post("/consolidate/portfolio/sendMailPortfolioReport", payload, { signal }),
};
